var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23530",
    "data-name": "Group 23530",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.648,
    height: 16.018,
    viewBox: "0 0 13.648 16.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63647",
    "data-name": "Rectangle 63647",
    width: 13.648,
    height: 16.018,
    fill: "#0c66e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23529",
    "data-name": "Group 23529",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29651",
    "data-name": "Path 29651",
    d: "M0,8Q0,5.015,0,2.029A1.886,1.886,0,0,1,1,.253,1.881,1.881,0,0,1,3.025.342q4.78,2.973,9.558,5.946A2,2,0,0,1,13.648,8a1.872,1.872,0,0,1-.942,1.712c-1.023.64-2.049,1.271-3.076,1.905q-3.3,2.042-6.6,4.084A1.956,1.956,0,0,1,0,14.02Q0,11.011,0,8",
    transform: "translate(0 0)",
    fill: "#0c66e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.fd18e27620586d53edc092d8216ffa3d.svg";
export { ForwardRef as ReactComponent };